export const ZHH_REALITY_CHECK_ALERT_ID = "ZHH_REALITY_CHECK_ALERT_ID";
export const ZHH_REALITY_CHECK_ALERT_TITLE_FINAL = "final";
export const ZHH_REALITY_CHECK_ALERT_TITLE_REMINDER = "reminder";
